import React from "react";
import PublicV2Layout from "../layout/PublicV2Layout";
import TermsOfService from "../../pages/PrivacyPolicy-TOS/TermsOfService";
import "./privacyTosV2.css";

/**
 * v2 chrome around the existing Terms of Service. Legal text reused as a single
 * source of truth (see PrivacyV2). Inner component supplies its own Helmet.
 */
const TermsV2 = (navProps) => (
  <PublicV2Layout {...navProps}>
    <div className="bdrv2-doc bdrv2-section">
      <div className="bdrv2-container">
        <TermsOfService />
      </div>
    </div>
  </PublicV2Layout>
);

export default TermsV2;
